<template lang="pug">
.column-selector.dropdown(
  v-tooltip.bottom="'Show/Hide Columns'"
  :class='{ open : isColumnSelectorOpened }'
  v-on-clickaway='closeColumnSelector'
)
  a.dropdown-toggle(href='#', data-toggle='dropdown', @click.prevent='openColumnSelector')
    i.fas.fa-columns
  .dropdown-menu(v-show='isColumnSelectorOpened')
    .column.selector.grid-filter
      //-span.close-icon(@click="closeColumnSelector")
        i.fal.fa-times
      p.column-title {{ t('Show') + '/' + t('Hide') + ' ' + t('Columns')  }}
      ed-input(:placeholder='t("Search")'
              v-model='search'
              search
              :ref="'input'"
      )
      .container
        .row
          .list.col-md-6
            p.column-title {{ t('Hidden') + ' ' + t('Columns') }}
            //ul.scroller.source(:placeholder='$t("Nothing to show")')
            transition-group.scroller.source(name='list' tag='ul' :placeholder='$t("Nothing to show")' @afterEnter='updateScroll' @afterLeave='updateScroll')
              li(v-for='column in filteredColumns' v-if='column.hide && hiddenColumn(column)' :key='column.field')
                span {{ column.headerName }}
                ed-button.btn.btn-actionbar.add-icon(@click='showColumn(column)')
                  i.fal.fa-chevron-right
          .list.col-md-6
            p.column-title {{ t('Shown') + ' ' + t('Columns') }}
            //ul.scroller.destination(:placeholder='$t("Nothing to hide")')
            transition-group.scroller.destination(name='list' tag='ul' :placeholder='$t("Nothing to hide")' @afterEnter='updateScroll' @afterLeave='updateScroll')
              li(v-for='column in filteredColumns' v-if='!column.hide && hiddenColumn(column)' :key='column.field')
                span {{ column.headerName }}
                //ed-button.btn.btn-actionbar.add-icon(@click='hideColumn(column)')
                  i.fal.fa-times
                i.fas.fa-times-circle.add-icon(@click='hideColumn(column)')
      br
      .alert.alert-danger(v-if='invalid' role='alert') You cannot hide all columns.
      ed-button.btn.btn-actionbar(@click='apply') {{ t('Apply') }}
      ed-button.btn.btn-actionbar(@click='revert') {{ t('clear.cancel') }}
      ed-button.btn.btn-actionbar(@click='revertDefault') {{ t('clear.default') }}
</template>

<script>

const hiddenCols = ['_', '+']

// import { EventBus } from '@/event-bus'
import PerfectScrollbar from 'perfect-scrollbar'
import { mixin as clickaway } from 'vue-clickaway'
import {i18n} from '@/lang/lang'

export default {
  name: 'column-selector',

  mixins: [ clickaway ],

  props: {
    columns: Array,
    api: Object
  },

  data() {
    return {
      invalid: false,
      isColumnSelectorOpened: false,
      search: '',
      columnsList: this.columns
    }
  },

  computed: {
    filteredColumns() {
      return this.columnsList.filter(column => column.headerName.toLowerCase().includes(this.search.toLowerCase()))
    }
  },

  created() {
    this.oColumns = utils.copy(this.columns)
    this.defaultColumns = utils.copy(this.columns)
  },

  mounted() {
    //
    const sourceViewport = this.$el.querySelector('.scroller.source')
    const destViewport = this.$el.querySelector('.scroller.destination')

    this.psSource = new PerfectScrollbar(sourceViewport, { minScrollbarLength: 20 })
    this.psDest = new PerfectScrollbar(destViewport, { minScrollbarLength: 20 })
  },

  methods: {
    t: (key) => i18n.t(key),

    openColumnSelector() {
      // update columns
      this.columnsList = this.$parent.gridOptions.columnApi.getAllColumns().map(column => ({
        field: column.colId,
        headerName: column.colDef.headerName,
        hide: !column.visible
      }))

      this.isColumnSelectorOpened = !this.isColumnSelectorOpened
      setTimeout(() => {
        this.$refs.input.$refs.input.focus()
        this.updateScroll()
      }, 50)
    },

    closeColumnSelector() {
      if (this.isColumnSelectorOpened) {
        this.isColumnSelectorOpened = false
        this.revert()
      }
    },

    updateScroll() {
      this.psSource.update()
      this.psDest.update()
    },

    hiddenColumn(column) {
      return hiddenCols.indexOf(column.headerName) === -1
    },

    hideColumn(column) {
      column.hide = true
    },

    showColumn(column) {
      column.hide = false
    },

    valid() {
      let valid = this.columnsList.filter(column => !column.hide && this.hiddenColumn(column)).length >= 1

      this.invalid = !valid
      return valid
    },

    apply() {
      if (!this.valid()) return

      const grid = this

      this.columnsList.forEach(column => {
        grid.$parent.gridOptions.columnApi.setColumnVisible(column.field, !column.hide)
      })

      this.oColumns = this.columnsList
      this.closeColumnSelector()
    },
    revert() {
      this.columnsList = utils.copy(this.oColumns)
    },
    revertDefault() {
      this.oColumns = this.columnsList
      this.columnsList = utils.copy(this.defaultColumns)
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.list-enter-active, .list-leave-active {
  transition: opacity .2s;
}
.list-enter, .list-leave-to {
  opacity: 0;
}

// COLUMN SELECTOR
.column-selector {
  display: inline-block;
  margin: 0 0 0 .4em;
  line-height: 1.5em;
  vertical-align: middle;
  cursor: pointer;

  .column.selector {
    //padding-bottom: 0px;
    line-height: 2em;
  }
  .dropdown-menu {
    margin-top: 0;
    left: auto;
    right: 0;
    padding: 0;
    cursor: default;
    min-width: 400px;

    .list {
      margin-left: -10px;

      .column-title {
        text-transform: none;
      }
    }

    .scroller {
      max-height: 200px;
        overflow: auto;
        position: relative;
    }

    ul, li {
      line-height: 2em;
      list-style-type: none;
      margin: 0;
      padding: 0;
      min-width: 150px;
      position: relative;
      min-height: 2em;
      @include theme {
      background: v(canvas);
      }

      .form-group {
        padding: 0;
      }

      .add-icon {
        float: right;
        padding: 0 5px;
        margin-top: 0.25rem;
        margin-bottom: 0;
        text-align: center;
        line-height: 1.3em;
      }
    }
    ul:before {
      content: attr(placeholder);
      @include theme {
      color: v(background);
      }
      font-size: $font-size-xsmall;
      font-style: italic;
      position: absolute;
      line-height: 1.8em;
    }
    li {
      white-space: normal;

      span {
        display: inline-block;
        line-height: 1em;
        vertical-align: middle;
        max-width: 85%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      @include theme {
      color: v(primary-04);
      }
      font-size: $font-size-xsmall;
      padding: 0 4px;

      &:hover {
        @include theme {
        background: v(secondary-04);
        }
        cursor: pointer;
      }
    }
  }

  .close-icon {
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    z-index: 9;

    line-height: normal;
    font-weight: 100;
    @include theme {
    color: v(ink);
    }
    margin-left: 2rem;
    text-align: right;
    &:hover {
      cursor: pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/column-selector.vue